<template>
<div>
    <v-card class="px-3 py-3">
        <v-row>
            <v-col class="5">
                <p>Full Name</p>
                <v-text-field
                    outlined
                    dense
                    :error-messages="nameErrors"
                    v-model="agreement.name"                    
                    required
                    @input="() => {
                        $v.agreement.name.$touch()
                        checkValid()
                    }"
                >
                </v-text-field>
            </v-col>
            <v-col class="5">
                <p>Contact E-mail</p>
                <v-text-field
                    outlined
                    dense
                    :error-messages="emailErrors"
                    v-model="agreement.email"                
                    required
                    @input="() => {
                        $v.agreement.email.$touch()
                        checkValid()
                    }"
                >
                </v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="5">
                <p>Title (Owner/Manger)</p>
                <v-text-field
                outlined
                dense
                :error-messages="titleErrors"
                v-model="agreement.title"                       
                required
                @input="() => {
                    $v.agreement.title.$touch()
                    checkValid()
                }"
                ></v-text-field>
            </v-col>
            <v-col class="5">
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="agreement.date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                         <p>Date</p>
                        <v-text-field
                            outlined
                            dense
                            :error-messages="dateErrors"
                            v-model="agreement.date"             
                            append-icon="mdi-calendar"
                            readonly
                            placeholder="mm/dd/yyy"
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="agreement.date"
                        no-title
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="menu = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(agreement.date)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <h4>Please provide an address to remit invoices to:</h4>
        <v-row>
            <v-col cols="12" md="6">
                <p>Billing Address</p>
                <v-text-field
                    :error-messages="mailingAdressErrors"
                    v-model="agreement.mailing_address"      
                    required
                    outlined
                    dense
                    @input="() => {
                        $v.agreement.mailing_address.$touch()
                        checkValid()
                    }"
                >
                </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <p>Email Address</p>
                <v-text-field
                    :error-messages="remitEmailErrors"
                    v-model="agreement.remitEmail"
                    required
                    outlined
                    dense
                    @input="() => {
                        $v.agreement.remitEmail.$touch()
                        checkValid()
                    }"
                >
            </v-text-field>   
            </v-col>     
        </v-row>
        <v-row>
            <v-col class="pt-0">
                <v-checkbox v-model="isAgreedTermsAndConditions"
                            :error-messages="isAgreedTermsAndConditionsErrors"
                            @change="() => {
                                $v.isAgreedTermsAndConditions.$touch()
                                checkValid()
                            }"
                >
                    <template slot="label">
                        <span>
                            I agree to the                          
                            terms and conditions                            
                            listed above.
                        </span>
                    </template>
                </v-checkbox>
            </v-col>
        </v-row>
  </v-card>
</div>
</template>

<script>
    import { required, email, sameAs} from 'vuelidate/lib/validators'
    export default {
        name: "AgreementForm",
        data: () => ({
            agreement: {},
            isAgreedTermsAndConditions: false,
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            modal: false,
            menu2: false,
        }),
        validations: {
            agreement: {
                name: { required },
                title: {required},
                date: {required},
                email: {required, email},
                mailing_address: {required},
                remitEmail: {required, email},
            },
            isAgreedTermsAndConditions: { sameAs: sameAs(() => true)}
        },
        methods: {
            checkValid() {
                if(this.$v.agreement.$invalid || this.$v.isAgreedTermsAndConditions.$invalid ) {
                    this.$store.commit('setValidInputs', false)
                } else {
                    this.$store.commit('setValidInputs', true)
                    this.$store.commit('setAgreementForm', this.agreement)
                }
            },
        },
        computed: {
            nameErrors () {
                const errors = []
                if (!this.$v.agreement.name.$dirty) return errors
                !this.$v.agreement.name.required && errors.push('Name is required')
                return errors
            },
            titleErrors () {
                const errors = []
                if (!this.$v.agreement.title.$dirty) return errors
                !this.$v.agreement.title.required && errors.push('Title is required')
                return errors
            },
            dateErrors () {
                const errors = []
                if (!this.$v.agreement.date.$dirty) return errors
                !this.$v.agreement.date.required && errors.push('Date is required')
                return errors
            },
            emailErrors () {
                const errors = []
                if (!this.$v.agreement.email.$dirty) return errors
                !this.$v.agreement.email.email && errors.push('A valid email is required')
                !this.$v.agreement.email.required && errors.push('Referral Email is required')
                return errors
            },
            remitEmailErrors () {
                const errors = []
                if (!this.$v.agreement.remitEmail.$dirty) return errors
                !this.$v.agreement.remitEmail.email && errors.push('A valid email is required')
                !this.$v.agreement.remitEmail.required && errors.push('Remit Email is required')
                return errors
            },
            mailingAdressErrors () {
                const errors = []
                if (!this.$v.agreement.mailing_address.$dirty) return errors
                !this.$v.agreement.mailing_address.required && errors.push('Mailing Address is required')
                return errors
            },
            isAgreedTermsAndConditionsErrors() {
                const errors = []
                if (!this.$v.isAgreedTermsAndConditions.$dirty) return errors;
                !this.$v.isAgreedTermsAndConditions.sameAs && errors.push('You must agree to the terms and conditions');
                return errors
            }
        },
        beforeMount () {
            this.checkValid();
        },
    }
</script>

<style lang="scss" scoped>

</style>